// @ts-expect-error Not Typed
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import memoizeOne from 'react-utils/memoizeOne';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { useHostAppName } from './hooks/useHostAppName';
import { useCallback, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import { jsx as _jsx } from "react/jsx-runtime";
const getUrl = memoizeOne(hostAppName => {
  const env = enviro.deployed() ? 'app' : 'local';
  return `${getFullUrl(env)}/chatspot-message-modal-ui/${PortalIdParser.get()}?hostAppName=${hostAppName}&variant=uiiframe`;
});
const CopilotFullscreenModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const hostAppName = useHostAppName();
  const closeModal = useCallback(() => {
    setIsVisible(false);
  }, []);
  const showModal = useCallback(() => {
    setIsVisible(true);
  }, []);
  useSubscribeToCopilotChannel('OPEN_FULLSCREEN_MESSAGE_VIEWER', showModal);
  useSubscribeToCopilotChannel('OPEN_ACTION_FORM', showModal);
  return /*#__PURE__*/_jsx(UIModalIFrame, {
    appName: "chatspot-message-modal-ui",
    height: "600",
    initTimeout: 20000,
    name: "chatspot-message-modal",
    onClose: closeModal,
    onMessage: emptyFunction,
    onReady: emptyFunction,
    preload: true,
    show: isVisible,
    showLoadingIndicator: true,
    src: getUrl(hostAppName),
    width: "1000"
  });
};
export default CopilotFullscreenModal;